export default __webpack_public_path__ + "assets/images/b9bc99b7633bf256a0621a3519149d73.svg";